var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "timeDialogContent" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择计划",
            visible: _vm.timeDialogVisible,
            center: "",
            "show-close": "",
            "custom-class": "timeDialog",
            width: "848px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.timeDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "mainContent" }, [
            _c(
              "div",
              { staticClass: "exam-list" },
              _vm._l(_vm.examList, function (item) {
                return _c(
                  "div",
                  {
                    key: item.examPlanId,
                    staticClass: "exam-item",
                    on: {
                      click: function ($event) {
                        return _vm.nextClick(item.examPlanId)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.examPlanName) + " ")]
                )
              }),
              0
            ),
            _c("div", { staticClass: "border" }),
            _c("div", { staticClass: "tips" }, [
              _vm._v(
                "备注：请考生根据自己拟报考的院校进行模拟练习，各学校考试大纲及考试形式详见各学校招生网站。"
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }